import type { User } from "@book-club/shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { membersKeys } from "@/features/members/queries/membersQueryKeys";
import membersService from "@/features/members/services/membersService";

export function useMemberLeaveAndCancellation(uid: string) {
    const queryClient = useQueryClient();

    const startLeave = useMutation({
        mutationFn: async (leaveReason: string) => {
            await membersService.startMemberLeave(uid, leaveReason);
        },
        onError: (error) => {
            toast.error(error instanceof Error ? error.message : "Failed to place member on leave.");
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: membersKeys.detail(uid) });
            queryClient.invalidateQueries({ queryKey: membersKeys.all });
            toast.success("Member placed on leave.");
        },
    });

    const endLeave = useMutation({
        mutationFn: async (member: User) => {
            await membersService.endMemberLeave(uid, member);
        },
        onError: (error) => {
            toast.error(error instanceof Error ? error.message : "Failed to end leave.");
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: membersKeys.detail(uid) });
            queryClient.invalidateQueries({ queryKey: membersKeys.all });
            toast.success("Leave ended.");
        },
    });

    return {
        endLeave,
        startLeave,
    };
}
